import i18n from '@/plugins/i18n'

/** 取得i18n翻譯 */
export const getI18nTranslate = (key: string, params: Record<string, any> = {}) => {
  return i18n.global.t(key, params)
}

/** 判斷 i18n key 是否存在，供 fallback 訊息選擇使用。 */
export const hasI18nTranslation = (key: string) => {
  return i18n.global.te(key)
}
